<template>
    <div class="capacity" v-if="show">{{ $t('general.capacity') }}: {{sum}}/{{storeLimit.limit}}</div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'Capacity',
    computed: {
      ...mapGetters(['storeLimit', 'storeOccupancy']),
      sum() {
        return this.storeOccupancy.sum < 0 ? 0 : this.storeOccupancy.sum;
      },

      show() {
        return this.storeLimit && typeof this.storeOccupancy !== undefined;
      }
    }
  };
</script>

<style scoped>

</style>